import {initSlickSlider, onScrollActivator} from './common';
export default {
    init() {
        initSlickSlider($('.product-main-slider'), {
            arrows:false,
            dots:false,
            infinite: true,
            autoplay:true,
            pauseOnHover:false,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            customPaging: function(slider, i) {
                return '<button> <span>' + $(slider.$slides[i]).find('.slide-item')[0].title + '</span></button>';
            },
        });

        var bannerswitcher_flag = false;
        $('body').on('change', '.bannerswitcher .toggle__input', function (){
            bannerswitcher_flag = !bannerswitcher_flag;
            $('.bannerswitcher .left, .bannerswitcher .right').toggleClass('text-white');
            if (bannerswitcher_flag) {
                $('.bannerswitcher .toggle__input').prop('checked', true);
                $('.product-main-slider').slick('slickGoTo', 1);
            } else{
                $('.bannerswitcher .toggle__input').prop('checked', false);
                $('.product-main-slider').slick('slickGoTo', 0);
            }
        });

        initSlickSlider($('.enhanced_experience_slider_text'), {
            asNavFor: '.enhanced_experience_slider_image',
            arrows: true,
        });

        initSlickSlider($('.enhanced_experience_slider_image'), {
            asNavFor: '.enhanced_experience_slider_text',
            arrows: true,
        });

        initSlickSlider($('.technology_slider_text'), {
            asNavFor: '.technology_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
            
        });
 

        initSlickSlider($('.technology_slider_image'), {
            asNavFor: '.technology_slider_text',
            arrows: true,
        });

        initSlickSlider($('.range_slider_text'), {
            asNavFor: '.range_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.range_slider_image'), {
            asNavFor: '.range_slider_text',
            arrows: true,
        });

        initSlickSlider($('.design_slider_text'), {
            asNavFor: '.design_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.design_slider_image'), {
            asNavFor: '.design_slider_text',
            arrows: true,
        });


        initSlickSlider($('.design_slider_2_text'), {
            asNavFor: '.design_slider_2_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.design_slider_2_image'), {
            asNavFor: '.design_slider_2_text',
            arrows: true,
        });

        initSlickSlider($('.design_slider_3'), {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            customPaging: function(slider, i) {
                return '<button> <span>' + $(slider.$slides[i]).find('.big-slide')[0].title + '</span></button>';
            },
        });

        initSlickSlider($('.cockpit_slider_text'), {
            asNavFor: '.cockpit_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.cockpit_slider_image'), {
            asNavFor: '.cockpit_slider_text',
            arrows: true,
        });

        initSlickSlider($('.cockpit_slider_2'), {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            customPaging: function(slider, i) {
                return '<button> <span>' + $(slider.$slides[i]).find('.big-slide')[0].title + '</span></button>';
            },
        });

        initSlickSlider($('.engine_slider_text'), {
            asNavFor: '.engine_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.engine_slider_image'), {
            asNavFor: '.engine_slider_text',
            arrows: true,
        });

        initSlickSlider($('.engine_slider_2_text'), {
            asNavFor: '.engine_slider_2_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.engine_slider_2_image'), {
            asNavFor: '.engine_slider_2_text',
            arrows: true,
        });

        initSlickSlider($('.special_edition_slider_text'), {
            asNavFor: '.special_edition_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.special_edition_slider_image'), {
            asNavFor: '.special_edition_slider_text',
            arrows: true,
        });

        initSlickSlider($('.comfort_slider_text'), {
            asNavFor: '.comfort_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.comfort_slider_image'), {
            asNavFor: '.comfort_slider_text',
            arrows: true,
            
        });

        initSlickSlider($('.driving_aids_slider_text'), {
            asNavFor: '.driving_aids_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.driving_aids_slider_image'), {
            asNavFor: '.driving_aids_slider_text',
            arrows: true,
        });

        initSlickSlider($('.accessories_slider_text'), {
            asNavFor: '.accessories_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.accessories_slider_image'), {
            asNavFor: '.accessories_slider_text',
            arrows: true,
        });

        initSlickSlider($('.business_slider_text'), {
            asNavFor: '.business_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.business_slider_image'), {
            asNavFor: '.business_slider_text',
            arrows: true,
        });

        initSlickSlider($('.connected_services_slider_text'), {
            asNavFor: '.connected_services_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.connected_services_slider_image'), {
            asNavFor: '.connected_services_slider_text',
            arrows: true,
        });

        initSlickSlider($('.connected_services_slider_2_text'), {
            asNavFor: '.connected_services_slider_2_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.connected_services_slider_2_image'), {
            asNavFor: '.connected_services_slider_2_text',
            arrows: true,
        });

        initSlickSlider($('.power_of_choice_slider_text'), {
            asNavFor: '.power_of_choice_slider_image',
            arrows: true,
            adaptiveHeight: ((window.screen.width <= 767) ? true : false),
        });

        initSlickSlider($('.power_of_choice_slider_image'), {
            asNavFor: '.power_of_choice_slider_text',
            arrows: true,
        });

        initSlickSlider($('.drivers_position_slider'), {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            customPaging: function(slider, i) {
                return '<button> <span>' + $(slider.$slides[i]).find('.big-slide')[0].title + '</span></button>';
            },
        });

        initSlickSlider($('.gallery_slider'), {
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            variableWidth: true,
            centerMode: false,
            autoplay: true,
        });

        onScrollActivator($('.subheader-menu'));
        // all products
        if($('.single-product').length > 0){
            var vehicle_Body_style = $('.home-banner').data('vehiclemodelbodystyle');
            var veicle_Body_style_label = $('.home-banner').data('vehiclemodelbodystylelabel');

            /* tslint:disable */ 
            window.dataLayer.push({
 
                'brand': 'peugeot',
                'virtualPageURL': window.location.pathname,
                'language': 'en',
                'country': 'pk',
                'siteTypeLevel1': 'www.peugeot-luckymotorcorp.com',
                'siteTypeLevel2': 'showroom',
                'siteOwner': 'local',
                'siteTarget': 'B2C',
                'siteFamily': 'new cars',
                'pageCategory': 'product page',
                'vehiculeModelBodystyle': vehicle_Body_style,
                'vehiculeModelBodystyleLabel': veicle_Body_style_label,
                'vehicleEngineType': '',
                'vehicleGearboxLabelEN': '',
             
            });
             /* tslint:enable */
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js